module.exports = __webpack_public_path__ + "img/attentionSigh.16d1639c.svg";